import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.slack.InstallPage.Success', {
    successMessage: 'The application was added to the workspace.',
    openSlack: 'Open ApprovalMax in Slack',
});
